export class Email {
    userid: number;
    subject: string; 
    data: string; 
	type: number;
	poid: number;
   
}